import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "External API", -1)
const _hoisted_3 = { class: "result-block-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "muted" }, "Result", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", null, " Call an external API by clicking the button below. This will call the external API using an access token, and the API will validate it using the API's audience value. " + _toDisplayString($setup.apiUrl), 1),
      _createElementVNode("button", {
        class: "btn btn-primary mt-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.callApi()))
      }, "Call API")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(['result-block', $setup.executed ? 'show' : ''])
      }, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(JSON.stringify($setup.apiMessage, null, 2)), 1)
      ], 2)
    ])
  ]))
}